import { render, staticRenderFns } from "./StagingTextSectionCitationDialog.vue?vue&type=template&id=4bf3944d"
import script from "./StagingTextSectionCitationDialog.vue?vue&type=script&lang=ts"
export * from "./StagingTextSectionCitationDialog.vue?vue&type=script&lang=ts"
import style0 from "./StagingTextSectionCitationDialog.vue?vue&type=style&index=0&id=4bf3944d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports